<div class="contenListFlights">
  <ng-container
    *ngIf="
      this.stateService.flightSelectedState.solutions &&
      this.stateService.flightSelectedState.solutions.length > 0
    "
  >
    <div
      class="card-content"
      *ngFor="
        let solution of this.stateService.flightSelectedState.solutions
          | slice: lowValue:highValue;
        let i = index
      "
    >
      <div class="associations" [ngClass]="{ 'associations-oneWay': oneWay }">
        <div
          *ngFor="let association of solution.data.associations; let j = index"
          class="association-container"
        >
          <div class="left">
            <div class="rowh">
              <div class="cardContentContainer">
                <div class="journey">
                  <div class="airline-container">
                    <img
                      class="airlineLogo"
                      [src]="
                        getLogo(
                          getSegment(association.journey_references[0]).object
                            .marketing_company
                        )
                      "
                      alt="logo"
                      width="72px"
                    />
                    <span class="flight-number">
                      {{
                        getSegment(association.journey_references[0]).object
                          .marketing_company
                      }}
                      {{
                        getSegment(association.journey_references[0]).object
                          .transport_number
                      }}
                    </span>
                    <span class="cabin-class">
                      {{ association.segment_references[0].object?.cabin?.short_name }}
                    </span>
                  </div>
                  <div class="origin">
                    <span class="colored">{{
                      getSegment(association.journey_references[0]).object.departure
                    }}</span>
                    <span class="bold"
                      >{{
                        getTime(
                          getSegment(association.journey_references[0]).object.departure_date
                        )
                      }}</span
                    >
                    <span>{{
                      formatDate(
                        getSegment(association.journey_references[0]).object.departure_date
                      )
                    }}</span>
                  </div>
                  <div class="iconFlight">
                    <img src="assets/img/svg/flight-takeoff.svg" alt="" />
                  </div>
                  <div class="linewrap">
                    <p
                      class="stops clickable-text"
                      (click)="toggleStops(i)"
                      *ngIf="getStops(association.journey_references[0]).length > 0; else elseBlock"
                    >
                      {{ getStops(association.journey_references[0]).length }}
                      {{
                        (getStops(association.journey_references[0]).length > 1
                          ? "flight.detail-flight.stops"
                          : "flight.detail-flight.stop"
                        ) | translate
                      }}
                      {{
                        getStops(association.journey_references[0]).join(", ")
                      }}
                    </p>
                    <ng-template #elseBlock>
                      <p class="stops">{{ "flight.result-flight.direct-flight" | translate }}</p>
                    </ng-template>
                    <div class="linesingle"></div>
                    <span class="duration">
                      {{
                        calcTotalSegmentTime(association.journey_references[0])
                      }}
                    </span>
                  </div>
                  <div class="iconFlight">
                    <img src="assets/img/svg/flight-landing.svg" alt="" />
                  </div>
                  <div class="destination">
                    <span class="colored">{{
                      getLastSegment(association.journey_references[0]).object
                        .arrival
                    }}</span>
                    <span class="bold"
                      >{{
                        getTime(
                          getLastSegment(association.journey_references[0])
                            .object.arrival_date
                        )
                      }}
                    </span>
                    <span>{{
                      formatDate(
                        getLastSegment(association.journey_references[0]).object
                          .arrival_date
                      )
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right">
        <!-- precio y boton-->
        <div class="colPrice">
          <div>
            <div>
              <h6>
                {{
                  (oneWay
                    ? "flight.result-flight.oneway-price"
                    : "flight.result-flight.return-price"
                  ) | translate
                }}
              </h6>
              <div style="margin: 0.5rem 0 !important;" *ngIf="!isPriceWithinRange(solution.total_price.total) || groupFilters.onlyFlightAuthorization">
                <span class="authorization-required">
                  {{ "authorization.required-auth" | translate }}
                </span>
              </div>
              <h6 class="my-auto price">
                {{ (solution.total_price.base + solution.total_price.total_taxes) | price }}€
              </h6>
            </div>
            <div id="right-button-container">
              <button (click)="getMultifamily(solution)" class="custom-btn">
                {{ ((!isPriceWithinRange(solution.total_price.total) || groupFilters.onlyFlightAuthorization) && isUser) ? ("flight.form-flight.request-flight" | translate) : ("flight.result-flight.book-flight" | translate) }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="layover-panel" *ngIf="openedStopsIndex.has(i)">
        <div class="layout-panel-custom">
          <div class="layover-item" *ngFor="let association of solution.data.associations; let j = index">
            <div class="layover-header" *ngIf="getLayoverInfo(association.journey_references[0]).length > 0">
              <strong>
                {{
                  oneWay
                    ? ("flight.detail-flight.scale-details-outbound" | translate)
                    : (j === 0
                        ? ("flight.detail-flight.scale-details-outbound" | translate)
                        : ("flight.detail-flight.scale-details-return" | translate))
                }}
              </strong>
            </div>
          <ng-container *ngFor="let layover of getLayoverInfo(association.journey_references[0])">
            <div class="layover-card">
              <div class="layover-airports-row">
                <div class="layover-airports">
                  <span class="airport-code">{{ layover.from }}</span>
                  <span class="layover-arrow">→</span>
                  <span class="airport-code">{{ layover.to }}</span>
                </div>
                <div class="layover-duration-inline">
                  {{ "flight.detail-flight.layover-duration" | translate }}:
                  <strong>{{ layover.duration }}</strong>
                </div>
              </div>
              <div class="layover-info-row">
                <div class="layover-times-visual">
                <div class="layover-time-block">
                  <img src="assets/img/svg/flight-landing.svg" alt="arrival" class="layover-icon" />
                  <div class="layover-time-info">
                    <div class="layover-label">
                      {{ "flight.detail-flight.arrival-time-to" | translate }} {{ layover.from }}
                    </div>
                    <div class="layover-time">{{ layover.arrivalTime }}</div>
                  </div>
                </div>
                <div class="layover-time-block">
                  <img src="assets/img/svg/flight-takeoff.svg" alt="departure" class="layover-icon" />
                  <div class="layover-time-info">
                    <div class="layover-label">
                      {{ "flight.detail-flight.departure-time-to" | translate }} {{ layover.to }}
                    </div>
                    <div class="layover-time">{{ layover.departureTime }}</div>
                  </div>
                </div>
                </div>
                <div class="layover-logo">
                  <div class="logo-wrapper">
                    <img
                      [src]="getLogo(layover.company)"
                      [alt]="layover.company"
                    />
                    <div class="flight-number">{{ layover.flightNumber }}</div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          </div>
        </div>
      </div>
    </div>
    <mat-paginator
      class="d-flex justify-content-center"
      [length]="this.stateService.flightSelectedState.solutions.length"
      [pageSize]="10"
      (page)="getPaginatorData($event)"
      [pageSizeOptions]="[5, 10, 25, 100]"
      showFirstLastButtons
      [hidePageSize]="true"
      style="border-radius: 15px"
    >
    </mat-paginator>
  </ng-container>
</div>
